import { useState } from "react";
import { useEffect } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import { deepCopyObject } from "../../utils/helpers";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniEditButton from "../ui/omniEditButton";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";
import SelectInviteDialog from "./selectInviteDialog";

// import {
//   fromCognitoIdentity,
//   fromCognitoIdentityPool,
//   fromWebToken,
// } from "@aws-sdk/credential-providers";

// ES6 import

// ES Modules import

const CommunicationTemplateDialog = props => {
  const {
    open,
    dialogTitle = "Email Template",
    okMessage = "OK",
    cancelMessage = "Cancel",
    deleteMessage = "Remove",
    maxWidth = "sm",
    fullWidth = true,
    organizationODM,
    communicationTemplateODM, //omni Data Model Object, a root level object representation, Pass in a COPY, the only way this works
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [editedCommunicationTemplateODM, setEditedCommunicationTemplateODM] =
    useState(communicationTemplateODM);

  // NAME
  const [nameValid, setNameValid] = useState(false);

  useEffect(() => {
    editedCommunicationTemplateODM.omniData.name ? setNameValid(true) : setNameValid(false);
  }, [editedCommunicationTemplateODM.omniData.name]);

  // subject
  const [subjectValid, setSubjectValid] = useState(false);

  // subject
  const [findSharedInvite, setFindSharedInvite] = useState(false);

  useEffect(() => {
    editedCommunicationTemplateODM.omniData.subject
      ? setSubjectValid(true)
      : setSubjectValid(false);
  }, [editedCommunicationTemplateODM.omniData.subject]);

  // S3
  const [s3Valid, setS3Valid] = useState(false);

  useEffect(() => {
    editedCommunicationTemplateODM.omniData.templateUrl ? setS3Valid(true) : setS3Valid(false);
  }, [editedCommunicationTemplateODM.omniData.templateUrl]);

  const updateEditedCommunicationTemplateODM = event => {
    try {
      editedCommunicationTemplateODM.omniData[event.target.id] = event.target.value;
      setEditedCommunicationTemplateODM(deepCopyObject(editedCommunicationTemplateODM));
    } catch (error) {
      console.log(error);
    }
  };

  const [showConfirm, setShowConfirm] = useState(false);

  const onDeleteHandler = () => {
    props.onDelete(editedCommunicationTemplateODM._id);
  };

  const [overrideEmailAddress, SetOverrideEmailAddress] = useState(
    constants.supportedEmailSourceAddresses.omnisciaHealthDotCom,
  );

  const onAcceptHandler = () => {
    try {
      if (editedCommunicationTemplateODM._id == null) {
        //this is the technically the "Template name" in our SES client, this just helps
        //keep those template names unique
        editedCommunicationTemplateODM.omniData.sesTemplateId = uuid();
      }

      editedCommunicationTemplateODM.omniData.overrideEmailSource = overrideEmailAddress;
      if (editedCommunicationTemplateODM == null) {
        console.log(
          `Set a Organization as Default EmailSource: ${organizationODM.omniData.emailSource}`,
        );
        editedCommunicationTemplateODM.omniData.overrideEmailSource =
          organizationODM.omniData.emailSource;
      }

      fetch(editedCommunicationTemplateODM.omniData.templateUrl)
        .then(res => {
          return res.blob();
        })
        .then(blobby => {
          let fileReader = new FileReader();
          fileReader.onload = event => {
            editedCommunicationTemplateODM.omniData.overrideReplyToAddress =
              organizationODM.omniData.emailReplyToAddress;

            props.onAccept(editedCommunicationTemplateODM);
          };
          fileReader.readAsText(blobby);
        })
        .catch(error => {
          enqueueSnackbar(`HTML File Error: ${error})`, {
            variant: "error",
          });
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  //VALIDATOR
  const [readyOk, setReadyOk] = useState(false);

  useEffect(() => {
    nameValid && subjectValid && s3Valid ? setReadyOk(true) : setReadyOk(false);
  }, [nameValid, subjectValid, s3Valid]);

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Typography variant="overline">{`Indentification`}</Typography>

          <Grid container item spacing={1}>
            <Grid item xs={12} sm={6}>
              <OmniTextField
                label="Template Name"
                type="textInput"
                name={uuid()} //prevents AutoComplete Suggestions
                variant="outlined"
                id={"name"}
                value={editedCommunicationTemplateODM.omniData.name}
                error={!nameValid}
                onChange={event => {
                  event.target.value = event.target.value.trim();
                  updateEditedCommunicationTemplateODM(event);
                }}
                placeholder={"Template Name"}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <OmniTextField
                label="Audience"
                type="textInput"
                name={uuid()} //prevents AutoComplete Suggestions
                variant="outlined"
                id={"communicationTarget"}
                value={editedCommunicationTemplateODM.omniData.communicationTarget}
                select
                onChange={event => {
                  event.target["id"] = "communicationTarget";
                  updateEditedCommunicationTemplateODM(event);
                }}
              >
                {constants.communicationTargets.map(commTarget => (
                  <OmniMenuItem key={commTarget.value} value={commTarget.value}>
                    {commTarget.label}
                  </OmniMenuItem>
                ))}
              </OmniTextField>
            </Grid>

            <Grid item xs={12}>
              <OmniTextField
                label="Description"
                type="textInput"
                name={uuid()} //prevents AutoComplete Suggestions
                variant="outlined"
                id={"description"}
                value={editedCommunicationTemplateODM.omniData.description}
                onChange={event => {
                  updateEditedCommunicationTemplateODM(event);
                }}
                placeholder={"What is this template used for?"}
                multiline
                rows={2}
              />
            </Grid>

            <Typography
              variant="overline"
              sx={{
                marginTop: theme.spacing(1),
                marginLeft: theme.spacing(1),
                marginBottom: `-${theme.spacing(1)}`,
              }}
            >
              {`Email Configuration`}
            </Typography>

            <Grid item xs={12}>
              <OmniTextField
                label="Subject"
                type="textInput"
                name={uuid()} //prevents AutoComplete Suggestions
                variant="outlined"
                id={"subject"}
                value={editedCommunicationTemplateODM.omniData.subject}
                error={!subjectValid}
                onChange={event => {
                  updateEditedCommunicationTemplateODM(event);
                }}
                placeholder={"Email Subject"}
                required
              />
            </Grid>

            <Grid item xs={10} sm={11}>
              <OmniTextField
                label="HTML Source"
                type="textInput"
                name={uuid()} //prevents AutoComplete Suggestions
                variant="outlined"
                id={"templateUrl"}
                value={editedCommunicationTemplateODM.omniData.templateUrl}
                error={!s3Valid}
                onChange={event => {
                  updateEditedCommunicationTemplateODM(event);
                }}
                placeholder={"An HTML Template URL"}
                required
              />
            </Grid>
            <Grid item xs={2} sm={1}>
              <Box sx={{ position: "relative" }}>
                <a
                  href={`${editedCommunicationTemplateODM.omniData.templateUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OmniEditButton
                    sx={{ top: 11 }}
                    title={"Preview Template"}
                    icon={<PreviewIcon size="large" />}
                    disabled={!s3Valid}
                    onClick={e => {}}
                  />
                </a>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="overline"
                sx={{
                  marginTop: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                  marginBottom: `-${theme.spacing(1)}`,
                }}
              >
                {`Source Email Address`}
              </Typography>

              <Grid item container xs={12}>
                <OmniTextField
                  label="Email Source Address"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"overrideEmailSource"}
                  value={overrideEmailAddress}
                  onChange={event => {
                    SetOverrideEmailAddress(event.target.value);
                  }}
                  select
                >
                  {Object.entries(constants.supportedEmailSourceAddresses).map(sourceEmail => (
                    <OmniMenuItem key={sourceEmail[0]} value={sourceEmail[1]}>
                      {sourceEmail[1]}
                    </OmniMenuItem>
                  ))}
                </OmniTextField>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Typography
                variant="overline"
                sx={{
                  marginTop: theme.spacing(1),
                  marginLeft: theme.spacing(1),
                  marginBottom: `-${theme.spacing(1)}`,
                }}
              >
                {`Shared Invite Key`}
              </Typography>

              <Grid item container xs={12}>
                <Grid item xs={10}>
                  <OmniTextField
                    label="Invite Key"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"sharedInviteKey"}
                    value={editedCommunicationTemplateODM.omniData.sharedInviteKey}
                    onChange={event => {
                      updateEditedCommunicationTemplateODM(event);
                    }}
                    placeholder={"If the Email Template Uses A Shared Invite key"}
                  />
                </Grid>

                <Grid item xs={2}>
                  <Box sx={{ position: "relative" }}>
                    <OmniEditButton
                      sx={{ top: 11 }}
                      title={"Search For Shared Invite"}
                      icon={<SearchIcon size="large" />}
                      onClick={() => {
                        setFindSharedInvite(true);
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item xs={6}>
            {communicationTemplateODM._id != null && props.onDelete != null && (
              <OmniResponsiveButton
                icon={<DeleteIcon />}
                onClick={() => setShowConfirm(true)}
                buttonText={deleteMessage}
                tooltipTitle=""
              />
            )}
          </Grid>
          <Grid container item justifyContent="flex-end" xs={6} spacing={1}>
            <Grid item>
              {cancelMessage && (
                <Button onClick={onCloseHandler} color="secondary" variant="contained">
                  {cancelMessage}
                </Button>
              )}
            </Grid>
            <Grid item>
              <Button
                onClick={onAcceptHandler}
                color="secondary"
                disabled={!readyOk}
                variant="contained"
              >
                {communicationTemplateODM._id != null ? "Update" : okMessage}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>

      {findSharedInvite && (
        <SelectInviteDialog
          open={findSharedInvite}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want delete this Template?"}
          onClose={() => {
            setFindSharedInvite(false);
          }}
          onSelectSharedInvite={inviteODM => {
            if (inviteODM._id != null) {
              let event = {
                target: { id: "sharedInviteKey", value: inviteODM._id },
              };
              updateEditedCommunicationTemplateODM(event);
            }
          }}
        />
      )}
      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want delete this Template?"}
          onAccept={() => {
            setShowConfirm(false);
            onDeleteHandler();
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default CommunicationTemplateDialog;
